// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop: () => void = () => {};

const noopObj = {};
Object.freeze(noopObj);

export { noopObj };
